<template>
  <login-layout :title="layoutTit">
    <div class="invite-login-tit">
      {{ $t('message["471"]') }} <span>
        <template v-if="projectname">
          {{ comname }}-{{ projectname }}
        </template>
        <template v-else>
          {{ comname }}
        </template></span>
    </div>
    <div class="accout-login invite-login">
      <a-form
        :form="form"
        @submit.prevent="submitForm"
      >
        <a-form-item label="">
          <a-input
            v-decorator="decorators.mobile"
            :placeholder="mobileTit"
          />
        </a-form-item>
        <a-form-item
          label=""
          class="password-box"
        >
          <a-input
            v-decorator="decorators.checkcode"
            :placeholder="validTit"
            class="password-input"
          />
          <get-code
            class="find-pwd-link"
            :is-disabled="isDisabled"
            type="10"
            :mobile="form.getFieldValue('mobile')"
            @getRes="getRes"
          />
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
          >
            {{ $t('message["597"]') }}
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </login-layout>
</template>
<script>
import LoginLayout from '@/components/pc/account/LoginLayout'
import GetCode from '@/components/pc/GetCode.vue'
import { mapActions, mapState } from 'vuex'
export default {
  'name': 'InviteLogin',
  components: {
    LoginLayout,
    GetCode
  },
  data () {
    return {
      isDisabled: false,
      submiting: false,
      inviteLogin: {
        checkuserid: '',
        isreg: 0,
        invitecode: this.$route.query.invitecode // this.$route.query.invitecode || ''
      },
      getCodeUrl2: ''
    }
  },
  computed: {
    ...mapState('organization/inviteJoin', ['decorators']),
    comname () {
      return this.$route.query.comname
    },
    projectname () {
      return this.$route.query.projectname
    },
    mobileTit () {
      return this.$t('message["1112"]')
    },
    layoutTit () {
      return this.$t('message["1381"]')
    },
    validTit () {
      return this.$t('message["1433"]')
    }
    // invitecode () {
    //   return this.$route.query.invitecode
    // }
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  async mounted () {
  },
  methods: {
    ...mapActions('team/invite', ['fetchLoginOrRegisterInvite']),
    submitForm (formName) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const obj = Object.assign(values, this.inviteLogin)
          const chain = await this.fetchLoginOrRegisterInvite(obj)
          chain.fetch()
        }
      })
    },
    getRes (payload) {
      this.inviteLogin.checkuserid = payload.checkuserid
    },
    resetForm (formName) {
      this.$refs[formName].resetFields()
    },
    getCodeValid (from, tel) {
    },
    inputChange () {
      this.isDisabled = false
    }
  }
}
</script>

<style lang="scss" scoped >
.invite-login-tit {
  height: 24px;
  line-height: 24px;
  padding: 8px 0;
  font-weight: bold;
  text-align: center;
  margin-top: 20px;

  span {
    margin: 0 10px;
  }
}

.invite-login {
  padding-top: 30px;

  .login-btn {
    display: block;
    width: 100%;
  }

  // .password-box {
  //   position: relative;

  //   .find-pwd-link {
  //     position: absolute;
  //     right: 16px;
  //     top: 0;

  //     .js-code-bbt {
  //       background: none;
  //       border: 0;
  //       color: #5077aa;
  //       padding: 0;
  //     }

  //     .el-button.is-disabled {
  //       color: #c0c4df;
  //       background: none;
  //     }
  //   }
  // }
}
</style>
